import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';

const inputStyle = { width: "100%", padding: "10px 14px", borderRadius: 9, border: "0.5px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.06)", fontSize: 14, color: "#f0efe9", outline: "none", boxSizing: "border-box" };

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (!form.newPassword || !form.confirmPassword) { setError('Please fill in all fields.'); return; }
    if (form.newPassword !== form.confirmPassword) { setError('Passwords do not match.'); return; }
    if (form.newPassword.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (!token) { setError('Invalid reset link. Please request a new one.'); return; }

    setLoading(true);
    try {
      await api.resetPassword({ token, newPassword: form.newPassword });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const wrap = { minHeight: "100vh", background: "#0e0e0c", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24 };
  const card = { width: "100%", maxWidth: 400, background: "rgba(255,255,255,0.04)", border: "0.5px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "36px 32px" };

  const logo = (
    <button onClick={() => navigate('/')} style={{ display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer", marginBottom: 40 }}>
      <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg,#7F77DD,#1D9E75)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>F</span>
      </div>
      <span style={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.8px", color: "#f0efe9" }}>FLO</span>
    </button>
  );

  if (!token) {
    return (
      <div style={wrap}>
        {logo}
        <div style={card}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "#f0efe9", marginBottom: 8, letterSpacing: "-0.5px" }}>Invalid link</h1>
          <p style={{ fontSize: 13, color: "rgba(240,239,233,0.55)", marginBottom: 24 }}>This reset link is missing or malformed. Please request a new one.</p>
          <button onClick={() => navigate('/login')} style={{ background: "none", border: "none", color: "#AFA9EC", cursor: "pointer", fontSize: 13, fontWeight: 500 }}>← Back to sign in</button>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div style={wrap}>
        {logo}
        <div style={card}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "#f0efe9", marginBottom: 8, letterSpacing: "-0.5px" }}>Password updated</h1>
          <p style={{ fontSize: 13, color: "rgba(240,239,233,0.55)", marginBottom: 24 }}>Your password has been changed. You can now sign in with your new password.</p>
          <button onClick={() => navigate('/login')} style={{ width: "100%", padding: "11px", borderRadius: 9, border: "none", background: "#534AB7", color: "#fff", fontSize: 14, cursor: "pointer", fontWeight: 600 }}>
            Sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={wrap}>
      {logo}
      <div style={card}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#f0efe9", marginBottom: 6, letterSpacing: "-0.5px" }}>Set new password</h1>
        <p style={{ fontSize: 13, color: "rgba(240,239,233,0.45)", marginBottom: 28 }}>Choose a strong password of at least 8 characters.</p>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(240,239,233,0.5)", marginBottom: 5 }}>New password</div>
            <input value={form.newPassword} onChange={e => setForm(f => ({ ...f, newPassword: e.target.value }))} type="password" placeholder="••••••••" style={inputStyle} />
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(240,239,233,0.5)", marginBottom: 5 }}>Confirm new password</div>
            <input value={form.confirmPassword} onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))} type="password" placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && handleSubmit()} style={inputStyle} />
          </div>
        </div>

        {error && <div style={{ marginTop: 12, fontSize: 12, color: "#F09595", padding: "8px 12px", borderRadius: 7, background: "rgba(226,75,74,0.1)", border: "0.5px solid rgba(226,75,74,0.2)" }}>{error}</div>}

        <button onClick={handleSubmit} disabled={loading} style={{ marginTop: 20, width: "100%", padding: "11px", borderRadius: 9, border: "none", background: "#534AB7", color: "#fff", fontSize: 14, cursor: "pointer", fontWeight: 600, opacity: loading ? 0.7 : 1 }}>
          {loading ? "Updating..." : "Set new password"}
        </button>

        <div style={{ marginTop: 20, textAlign: "center" }}>
          <button onClick={() => navigate('/login')} style={{ background: "none", border: "none", color: "#AFA9EC", cursor: "pointer", fontSize: 13, fontWeight: 500 }}>← Back to sign in</button>
        </div>
      </div>
    </div>
  );
}
